import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from './icon.component';
import { SHEETS_STRINGS } from '@sharedlib/sheets-editor/sheets.strings';

/**
 * What the menu can ask the host to do. `xlsx`/`xls`/`ods`/`pdf` are declared here
 * even though this demo cannot produce them — the host answers with an honest
 * message rather than the menu pretending the entry does not exist.
 */
export type DownloadAction = 'xlsx' | 'xls' | 'ods' | 'pdf' | 'csv' | 'tsv' | 'import' | 'import-csv' | 'shortcuts' | 'share';

/**
 * Download and share menu, per Wook's annotated screenshot of 25 Sep.
 *
 * Two of his edits are baked in and must not drift back:
 *   AM-34 — there is NO "<vendor> workbook (.json)" entry. It sat between the PDF
 *           and CSV items in his prototype and is struck through in the annotation.
 *           See docs/for-wook-round-2.md §3b: removing it also removes the only
 *           lossless export, which is a question still open with him.
 *   AM-35 — the last item reads "Share via link", not "Copy link to workbook".
 */
@Component({
  selector: 'app-download-menu',
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './download-menu.component.html',
  styleUrls: ['./download-menu.component.less'],
})
export class DownloadMenuComponent {
  /** NFR-8: Appendix F's strings, from their one definition. */
  protected readonly S = SHEETS_STRINGS;
  /** "Share via link" shares a workbook; an editor bound to none (the spike page) has nothing to share. */
  @Input() public share = true;
  @Output() public readonly action = new EventEmitter<DownloadAction>();

  protected pick(a: DownloadAction): void {
    this.action.emit(a);
  }
}
